import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
var _effectorFileName = "/builds/gmini/front-common/src/Services/EstimationService/EstimationService.ts";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.array.concat.js";
import { map, pipe, prop } from 'ramda';
import { createEvent, forward, merge } from 'effector';
import { createGate } from 'effector-react';
import { isIOTSErrorResult, isJsendBadResultError, isJsendBadResultFail } from '@gmini/api-call-service';
import { NormalizedTree } from '@gmini/normalized-tree';
import { createChildDomain } from '@gmini/utils';
import * as smApi from '@gmini/sm-api-sdk';
import * as estApi from '@gmini/sm-api-sdk/lib/EstimationApi';
import { createPropertyStoreService } from "../PropertyService";
import * as n from "./Node";
import { createEstimationCalculateService } from "./EstimationCalculateService";
import { createEstimationStoreService, buildEstimationStatusKey } from "./EstimationStoreService";
export function createEstimationService(options) {
  var domain = createChildDomain(options.parentDomain, 'EstimationService');
  var reset = domain.event('reset', {
    name: "reset",
    sid: "-ft2xc1"
  });
  var Gate = createGate({
    name: 'Mount',
    domain: domain
  });
  forward({
    ɔ: {
      from: Gate.close,
      to: reset
    },
    config: {
      sid: "p0u23e"
    }
  });
  var notification = domain.event('notification', {
    name: "notification",
    sid: "-dbrfdr"
  });
  var created = notification.filter({
    fn: estApi.NotificationEvent.Create.is
  }).map(prop('payload'));
  var updated = notification.filter({
    fn: estApi.NotificationEvent.Update.is
  }).map(prop('payload'));
  var removed = notification.filter({
    fn: estApi.NotificationEvent.Remove.is
  }).map(prop('payload'));
  var estimationStatusChanged = notification.filter({
    fn: estApi.NotificationEvent.EstimationStatusChange.is
  }).map(prop('payload'));
  var estimation = createEstimationStoreService({
    updatedEvent: updated
  });
  var elementPropertiesListEvent = smApi.UserClassifierGroup.Property.List.fetchElementProperties.done.map(function (_ref) {
    var _ref$params = _ref.params,
        classifierId = _ref$params.classifierId,
        groupId = _ref$params.groupId,
        elementProperties = _ref.result.elementProperties;
    return {
      properties: elementProperties,
      key: buildClsGroupKey({
        classifierId: classifierId,
        groupId: groupId
      })
    };
  });
  var simpleFieldsPropertiesEvent = estApi.Estimation.getMostRecent.defaultContext.doneData.map(function (_ref2) {
    var calculations = _ref2.calculations;
    return calculations.reduce(function (acc, calculation) {
      return [].concat(_toConsumableArray(acc), _toConsumableArray(calculation.simpleFieldsProperties));
    }, []);
  });
  var standardSizePropertiesListEvent = smApi.UserClassifierGroup.Property.List.fetchStandardSizeProperties.done.map(function (_ref3) {
    var _ref3$params = _ref3.params,
        classifierId = _ref3$params.classifierId,
        groupId = _ref3$params.groupId,
        standardSizeProperties = _ref3.result.standardSizeProperties;
    return {
      properties: standardSizeProperties,
      key: buildClsGroupKey({
        classifierId: classifierId,
        groupId: groupId
      })
    };
  });
  var complexFieldsPropertiesEvent = estApi.Estimation.getMostRecent.defaultContext.doneData.map(function (_ref4) {
    var calculations = _ref4.calculations;
    return calculations.reduce(function (acc, calculation) {
      return [].concat(_toConsumableArray(acc), _toConsumableArray(calculation.complexFieldsProperties));
    }, []);
  });
  var elementProps = createPropertyStoreService({
    getPropertiesListEvent: elementPropertiesListEvent,
    applyPropertiesEvent: merge([complexFieldsPropertiesEvent, simpleFieldsPropertiesEvent], {
      name: "applyPropertiesEvent",
      sid: "3ej7sl"
    })
  });
  var standardSizeProps = createPropertyStoreService({
    getPropertiesListEvent: standardSizePropertiesListEvent,
    applyPropertiesEvent: createEvent({
      name: "applyPropertiesEvent",
      sid: "h4u988"
    })
  });
  var estimationCalculation = createEstimationCalculateService();
  estimationCalculation.calculation$ // Обновляем, если пришло ws уведомление
  .on(updated.filter({
    fn: estApi.EstimationCalculation.is
  }), function (state, calculation) {
    return _objectSpread(_objectSpread({}, state), {}, _defineProperty({}, calculation.id, calculation));
  }).on(updated.filter({
    fn: estApi.Estimation.is
  }), function (_state, estimation) {
    return estimation.calculations.reduce(function (acc, item) {
      acc[item.id] = item;
      return acc;
    }, {});
  }) // Обновляем, если создан новый экземпляр
  .on(estApi.EstimationCalculation.create.doneData, function (state, calculation) {
    return _objectSpread(_objectSpread({}, state), {}, _defineProperty({}, calculation.id, calculation));
  });
  estimation.estimationStatus$.on(estimationStatusChanged, function (data, _ref5) {
    var version = _ref5.version,
        id = _ref5.id,
        status = _ref5.status;
    return _objectSpread(_objectSpread({}, data), {}, _defineProperty({}, buildEstimationStatusKey({
      estimationId: id,
      estimationVersion: version
    }), status));
  });
  var badResult = merge([estApi.EstimationRepoFolder.create.failData, estApi.EstimationRepoFolder.rename.failData, estApi.EstimationRepoFolder.move.failData, estApi.EstimationRepoFolder.remove.failData, estApi.Estimation.create.failData, estApi.Estimation.copy.failData, estApi.Estimation.rename.failData, estApi.Estimation.move.failData, estApi.Estimation.remove.failData, estApi.Estimation.getMostRecent.failData, estApi.Estimation.ImportEstimation.failData, estApi.Estimation.start.failData, estApi.Estimation.fetchStatus.failData, estApi.Estimation.renameVersion.failData, estApi.Estimation.removeVersionName.failData, estApi.Estimation.fetchNamedVersions.failData, estApi.Estimation.fetchVersionByDate.failData, estApi.Estimation.fetchVersionDates.failData, estApi.Estimation.changeStatus.failData, estApi.EstimationRepo.Populated.fetch.failData, // estApi.Property.List.fetchByRule.failData, // договорились убрать пока не разделим на 2 эндпоинта
  // estApi.CheckupRule.fetchStatus.failData,
  estApi.EstimationCalculation.updateFields.failData], {
    name: "badResult",
    sid: "-9xuw5j"
  });
  var fail = badResult.filter({
    fn: isJsendBadResultFail
  });
  var error = badResult.filter({
    fn: isJsendBadResultError
  });
  var IOTSError = badResult.filter({
    fn: isIOTSErrorResult
  });
  var getEstimationRepoPopulated = estApi.EstimationRepo.Populated.fetch.done.map(function (_ref6) {
    var params = _ref6.params,
        result = _ref6.result;
    return _objectSpread(_objectSpread({}, result), {}, {
      id: params.projectUrn
    });
  });
  var getRepoOrFolder = merge([getEstimationRepoPopulated, estApi.EstimationRepoFolder.Populated.fetch.doneData, estApi.EstimationRepoFolder.Populated.fetchSilent.doneData], {
    name: "getRepoOrFolder",
    sid: "-dqvpyk"
  });
  var normalizedTree = new NormalizedTree();
  normalizedTree.index$.on(getEstimationRepoPopulated.map(function (data) {
    return n.EstimationRepoNode.create(data);
  }), updateNode(['name', 'total', 'offset'])).on(updated.filter({
    fn: estApi.EstimationRepo.is
  }).map(n.EstimationRepoNode.create), updateNode(['name', 'total'])).on(getRepoOrFolder.map(pipe(prop('children'), filter(estApi.Estimation.is), map(n.EstimationNode.create))), updateNodes(['parentFolderId', 'parentKey', 'name', 'version', 'classifierId', 'classifierVersion'])).on(getRepoOrFolder.map(pipe(prop('children'), filter(estApi.EstimationRepoFolder.is), map(n.EstimationRepoFolderNode.create))), updateNodes(['parentFolderId', 'parentKey', 'name', 'total'])).on(estApi.EstimationRepoFolder.create.doneData.map(n.EstimationRepoFolderNode.create), updateNode(['parentFolderId', 'parentKey', 'name', 'total'])).on(created.filter({
    fn: estApi.EstimationRepoFolder.is
  }).map(n.EstimationRepoFolderNode.create), updateNode(['parentFolderId', 'parentKey', 'name', 'total'])).on(estApi.EstimationRepoFolder.Populated.fetch.doneData.map(n.EstimationRepoFolderNode.create), updateNode(['parentFolderId', 'parentKey', 'name', 'total', 'offset'])).on(estApi.EstimationRepoFolder.rename.doneData.map(n.EstimationRepoFolderNode.create), updateNode(['name'])).on(estApi.EstimationRepoFolder.move.doneData.map(n.EstimationRepoFolderNode.create), updateNode(['parentFolderId', 'parentKey'])).on(updated.filter({
    fn: estApi.EstimationRepoFolder.is
  }).map(n.EstimationRepoFolderNode.create), updateNode(['parentFolderId', 'parentKey', 'name', 'total'])).on(estApi.EstimationRepoFolder.remove.doneData.map(n.EstimationRepoFolderNode.create), removeNode).on(removed.filter({
    fn: estApi.EstimationRepoFolder.is
  }).map(n.EstimationRepoFolderNode.create), removeNode).on(estApi.Estimation.create.doneData.map(n.EstimationNode.create), updateNode(['parentFolderId', 'parentKey', 'name', 'calculations'])).on(estApi.Estimation.copy.doneData.map(n.EstimationNode.create), updateNode(['parentFolderId', 'parentKey', 'name', 'calculations'])).on(created.filter({
    fn: estApi.Estimation.is
  }).map(n.EstimationNode.create), updateNode(['parentFolderId', 'parentKey', 'name', 'calculations'])).on(estApi.Estimation.getMostRecent.doneData.map(n.EstimationNode.create), updateNode(['parentFolderId', 'parentKey', 'name', 'calculations', 'version'])).on(estApi.Estimation.ImportEstimation.doneData.map(n.EstimationNode.create), updateNode(['parentFolderId', 'parentKey', 'name', 'calculations', 'version'])).on(estApi.Estimation.rename.doneData.map(n.EstimationNode.create), updateNode(['name', 'version'])).on(estApi.Estimation.move.doneData.map(n.EstimationNode.create), updateNode(['parentFolderId', 'parentKey', 'version'])).on(updated.filter({
    fn: estApi.Estimation.is
  }).map(n.EstimationNode.create), updateNode(['parentFolderId', 'parentKey', 'name', 'calculations', 'version'])).on(estApi.Estimation.remove.doneData.map(n.EstimationNode.create), removeNode).on(removed.filter({
    fn: estApi.Estimation.is
  }).map(n.EstimationNode.create), removeNode).reset(reset);
  return {
    Gate: Gate,
    nodes$: normalizedTree.index$,
    relations$: normalizedTree.relations$,
    estimation: estimation,
    estimationCalculation: estimationCalculation,
    elementProps: elementProps,
    standardSizeProps: standardSizeProps,
    estimationStatusChanged: estimationStatusChanged,
    notification: notification,
    badResult: badResult,
    fail: fail,
    error: error,
    IOTSError: IOTSError,
    reset: reset
  };
}

// TODO возможно пригодится
// type Mutable<T extends Readonly<Record<string | number | symbol, unknown>>> = {
//   [K in keyof T]: T[K]
// }
function filter(predicate) {
  return function (items) {
    return items.filter(predicate);
  };
}

function setNode(nodes, newNode) {
  var key = n.Node.getKey(newNode);
  var oldNode = nodes[key];

  if (newNode === oldNode) {
    return nodes;
  }

  return _objectSpread(_objectSpread({}, nodes), {}, _defineProperty({}, key, newNode));
}

var updateNode = function updateNode() {
  var properties = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return function (nodes, newNode) {
    var oldNode = n.Node.getByRef(nodes, newNode);

    if (!oldNode) {
      return setNode(nodes, newNode);
    }

    var changedProperties = properties.filter(function (property) {
      return oldNode[property] !== newNode[property];
    });

    if (!changedProperties.length) {
      return nodes;
    }

    return setNode(nodes, changedProperties.reduce(function (acc, property) {
      acc[property] = newNode[property];
      return acc;
    }, _objectSpread({}, oldNode)));
  };
};

var updateNodes = function updateNodes(properties) {
  return function (nodes, newNodes) {
    return newNodes.reduce(updateNode(properties), nodes);
  };
};

function removeNode(nodes, node) {
  var key = n.Node.getKey(node);

  if (!nodes[key]) {
    return nodes;
  }

  var newNodes = _objectSpread({}, nodes);

  delete newNodes[key];
  return newNodes;
}

export var buildClsGroupKey = function buildClsGroupKey(_ref7) {
  var classifierId = _ref7.classifierId,
      groupId = _ref7.groupId;
  return "".concat(classifierId, ":").concat(groupId);
};
export function getChildren(nodes, relations, ref) {
  var key = n.Node.getKey(ref);
  var childrenKeys = relations[key];

  if (!childrenKeys) {
    return [];
  }

  return childrenKeys.reduce(function (acc, key) {
    var node = nodes[key];

    if (node) {
      acc.push(node);
    }

    return acc;
  }, []);
}